import type { SheetLayout } from './sheetPagination';

interface SheetGapsProps {
  layout: SheetLayout;
  /** Editor: de ruimte tussen twee blokken voegt daar een pagina in (`data-after-block-id`). */
  insertGaps?: boolean;
}

/**
 * Webweergave: tussenruimtes tussen de vellen van één blok en een anker per vel
 * (paginateller). Ligt als overlay over het document en verandert de layout niet.
 */
export default function SheetGaps({ layout, insertGaps = false }: SheetGapsProps) {
  const anchors: JSX.Element[] = [];
  const gaps: JSX.Element[] = [];
  layout.blocks.forEach((block, blockIndex) => {
    for (let sheet = 0; sheet < block.sheetCount; sheet += 1) {
      const top = block.top + sheet * layout.pitch;
      anchors.push(
        <div
          key={`sheet-${anchors.length}`}
          data-sheet-index={anchors.length}
          style={{ position: 'absolute', top, left: 0, width: 1, height: layout.sheetHeight }}
        />
      );
      if (sheet < block.sheetCount - 1) {
        gaps.push(
          <div
            key={`gap-${block.id}-${sheet}`}
            className="shared-sheet-gap"
            style={{ top: top + layout.sheetHeight, height: layout.gap }}
          />
        );
      } else if (insertGaps && blockIndex < layout.blocks.length - 1) {
        gaps.push(
          <div
            key={`insert-${block.id}`}
            className="sheet-insert-gap"
            data-after-block-id={block.id}
            title="Pagina invoegen"
            style={{ top: top + layout.sheetHeight, height: layout.gap }}
          />
        );
      }
    }
  });
  return (
    <div
      aria-hidden
      data-sheet-overlay
      style={{ position: 'absolute', inset: 0, pointerEvents: 'none', zIndex: 40 }}
    >
      {anchors}
      {gaps}
    </div>
  );
}
